import { ReactNode } from "react";

import styles from "./SectionHeader.module.scss";

export interface SectionHeaderProps {
  /** Section title, rendered as the bar's heading. */
  title: ReactNode;
  /** Optional secondary text beside the title (e.g. version / timestamp). */
  subtitle?: ReactNode;
  /** Optional right-aligned content — action buttons, info control, etc. */
  actions?: ReactNode;
  /**
   * Extra class on the bar for caller-specific positioning, e.g. bleeding to a
   * card's edges or making the header sticky. The bar's own visual treatment
   * (tint, title, divider) comes from the component.
   */
  className?: string;
}

/**
 * Section-header bar shared across the condensed-report cards: a tinted band
 * with a bold section title, an optional inline subtitle, and an optional
 * right-aligned actions slot. The tint is composited over the card background so
 * the band stays opaque when a caller makes it sticky.
 */
const SectionHeader = ({
  title,
  subtitle,
  actions,
  className,
}: SectionHeaderProps) => (
  <div className={[styles.header, className].filter(Boolean).join(" ")}>
    <div className={styles.titleGroup}>
      <h2 className={styles.title}>{title}</h2>
      {subtitle != null && <span className={styles.subtitle}>{subtitle}</span>}
    </div>
    {actions != null && <div className={styles.actions}>{actions}</div>}
  </div>
);

export default SectionHeader;
